import React, { useEffect, useState, memo } from 'react';
import { ZapIcon, BookOpenIcon, SmartphoneIcon, HeartIcon, GlobeIcon, AlertCircleIcon } from 'lucide-react';
import { CountdownBadge } from './CountdownBadge';
import { LiveVisitorCounter } from './LiveVisitorCounter';
// Memoize the pricing card to prevent unnecessary re-renders
const PricingCard = memo(({
  showArgentinePrice,
  isLoading,
  handleBuyClick
}: {
  showArgentinePrice: boolean;
  isLoading: boolean;
  handleBuyClick: () => void;
}) => <div className="bg-white rounded-2xl shadow-xl border border-gray-200 max-w-md w-full mx-auto transform transition-transform hover:scale-[1.02] relative" data-id="element-276">
      {/* 75% OFF Badge positioned to extend outside the container */}
      <div className="absolute -top-4 -right-4 bg-red-600 text-white text-xs font-bold rounded-full h-14 w-14 flex items-center justify-center z-10 transform rotate-12 shadow-md" data-id="element-277">
        <span className="text-center leading-tight" data-id="element-278">
          <span className="text-lg" data-id="element-279">75%</span>
          <span className="block text-sm" data-id="element-280">OFF</span>
        </span>
      </div>
      <div className="p-6 bg-blue-900 text-white text-center" data-id="element-281">
        <h3 className="text-xl font-bold mb-2" data-id="element-282">BABY FOOD MADE SIMPLE</h3>
        <p className="text-blue-100" data-id="element-283">Complete Structured Feeding System</p>
      </div>
      <div className="p-6 space-y-6" data-id="element-284">
        <div className="text-center" data-id="element-285">
          {isLoading ? <p className="text-lg font-medium" data-id="element-286">Loading pricing...</p> : showArgentinePrice ? <>
              <p className="text-gray-500 line-through text-lg" data-id="element-287">
                ARS $ 17.500,00
              </p>
              <p className="text-3xl font-bold text-blue-900" data-id="element-288">ARS $ 9.990,00</p>
            </> : <>
              <p className="text-gray-500 line-through text-3xl" data-id="element-289">$60</p>
              <p className="text-6xl font-bold text-blue-900" data-id="element-290">$14.97</p>
            </>}
          <div className="mt-2 text-sm text-red-600 font-medium" data-id="element-291">
            Limited time offer!{' '}
            <span className="block mt-1" data-id="element-292">
              Price returns to $60 after timer expires
            </span>
          </div>
        </div>
        <div className="space-y-3" data-id="element-293">
          <div className="flex items-start" data-id="element-294">
            <div className="flex-shrink-0" data-id="element-295">
              <BookOpenIcon className="h-5 w-5 text-green-500 mt-0.5" data-id="element-296" />
            </div>
            <div className="ml-3" data-id="element-297">
              <p className="text-gray-800 font-medium" data-id="element-298">
                Instant digital access
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-299">
            <div className="flex-shrink-0" data-id="element-300">
              <SmartphoneIcon className="h-5 w-5 text-green-500 mt-0.5" data-id="element-301" />
            </div>
            <div className="ml-3" data-id="element-302">
              <p className="text-gray-800 font-medium" data-id="element-303">Access on any device</p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-304">
            <div className="flex-shrink-0" data-id="element-305">
              <HeartIcon className="h-5 w-5 text-green-500 mt-0.5" data-id="element-306" />
            </div>
            <div className="ml-3" data-id="element-307">
              <p className="text-gray-800 font-medium" data-id="element-308">
                See results from day one
              </p>
            </div>
          </div>
        </div>
        <a href="https://thinkarox.com/cart/46697456894182:1?channel=buy_button" className="w-full bg-yellow-500 hover:bg-yellow-400 text-blue-900 font-bold py-3 px-6 rounded-lg transition-colors flex items-center justify-center text-lg no-underline cta" data-id="element-309">
          <ZapIcon className="h-5 w-5 mr-2" data-id="element-310" />
          Get The eBook Now
        </a>
        <p className="text-xs text-center text-gray-500" data-id="element-311">
          One-time payment. No subscriptions or hidden fees.
        </p>
      </div>
      <div className="p-6 bg-gray-50 text-center border-t border-gray-200" data-id="element-312">
        <p className="text-sm font-medium text-gray-700" data-id="element-313">From chaos to calm.</p>
        <p className="text-sm font-bold text-gray-900 mt-1" data-id="element-314">
          One meal at a time.
        </p>
      </div>
    </div>);
export function PricingSection() {
  return <section id="pricing" className="py-8 bg-gradient-to-b from-white to-blue-50" data-id="element-315">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-316">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-317">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-318">
            Limited Launch Offer
          </h2>
          <div className="h-1 w-20 bg-yellow-500 mx-auto mb-6" data-id="element-319"></div>
          <p className="text-lg text-gray-700 mb-8" data-id="element-320">
            <strong data-id="element-321">For a limited time,</strong> get complete access BABY FOOD MADE SIMPLE at our
            special introductory price.
          </p>
          <CountdownBadge data-id="element-322" />
        </div>
        <div className="mt-8" data-id="element-323">
          <PricingCard data-id="element-324" />
        </div>
      </div>
    </section>;
}